function initManualReadmore() {
  const groups = document.querySelectorAll(".readmore-group-manual");

  if (!groups.length) return;

  groups.forEach((group) => {
    const extra = group.querySelector(".readmore-extra");
    const toggler = group.querySelector(".readmore-toggler");

    if (!extra || !toggler) return;

    function toggleReadmore(e) {
      e.preventDefault();

      const isExpanded = group.classList.toggle("is-expanded");

      toggler.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.textContent.trim();
          if (text) {
            if (isExpanded) {
              node.textContent = node.textContent
                .replace("Read more", "Read less")
                .replace("More", "Less");
            } else {
              node.textContent = node.textContent
                .replace("Read less", "Read more")
                .replace("Less", "More");
            }
          }
        }
      });
    }

    toggler.addEventListener("click", toggleReadmore);
  });
}

export default function initReadmore() {
  initManualReadmore();

  const readmoreGroups = document.querySelectorAll(".readmore-group");

  if (!readmoreGroups.length) return;

  readmoreGroups.forEach((group) => {
    const content = group.querySelector(".readmore-content");
    const toggler = group.querySelector(".readmore-toggler");

    if (!content || !toggler) return;

    // Set CSS variable from data-line attribute
    const lineCount = group.dataset.line;
    if (lineCount) {
      group.style.setProperty("--line", lineCount);
    }

    // Check if content is truncated
    function checkTruncation() {
      // If already expanded, always show toggler
      if (group.classList.contains("is-expanded")) {
        toggler.style.display = "";
        return;
      }

      // Temporarily remove line-clamp to measure natural height
      content.style.webkitLineClamp = "unset";
      const naturalHeight = content.scrollHeight;
      content.style.webkitLineClamp = "";
      const clampedHeight = content.clientHeight;

      if (naturalHeight > clampedHeight) {
        toggler.style.display = "";
      } else {
        toggler.style.display = "none";
      }
    }

    // Initial check
    checkTruncation();

    // If inside a hidden panel, recheck when it becomes visible
    const panel = group.closest(".panel");
    if (panel && !panel.classList.contains("active")) {
      const observer = new MutationObserver(() => {
        if (panel.classList.contains("active")) {
          checkTruncation();
          observer.disconnect();
        }
      });
      observer.observe(panel, { attributes: true, attributeFilter: ["class"] });
    }

    // If already expanded on init, update text
    if (group.classList.contains("is-expanded")) {
      toggler.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.textContent.trim();
          if (text) {
            node.textContent = node.textContent
              .replace("Read more", "Read less")
              .replace("More", "Less");
          }
        }
      });
    }

    // Recheck on resize
    window.addEventListener("resize", checkTruncation);

    function toggleReadmore(e) {
      e.preventDefault();

      const isExpanded = group.classList.toggle("is-expanded");

      // Update text
      toggler.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.textContent.trim();
          if (text) {
            if (isExpanded) {
              node.textContent = node.textContent
                .replace("Read more", "Read less")
                .replace("More", "Less");
            } else {
              node.textContent = node.textContent
                .replace("Read less", "Read more")
                .replace("Less", "More");
            }
          }
        }
      });
    }

    toggler.addEventListener("click", toggleReadmore);
  });
}
